export default __webpack_public_path__ + "images/onboarding/C-649b6e4864a3c909ab06b80326cb3ff8.svg";